import Button from './src/components/Button.vue'
import ButtonGroup from './src/components/Button-group.vue'
import Icon from './src/components/Icon.vue'
import Col from './src/components/Icon'
import Collapse from './src/components/Collapse'
import CollapseItem from './src/components/CollapseItem'
import Content from './src/components/Content'
import Footer from './src/components/Footer'
import Header from './src/components/Header'
import Input from './src/components/Input'
import Layout from './src/components/Layout'
import Popover from './src/components/Popover'
import Row from './src/components/Row'
import Sider from './src/components/Sider'
import Tabs from './src/components/Tabs'
import TabsBody from './src/components/TabsBody'
import TabsHead from './src/components/TabsHead'
import TabsItem from './src/components/TabsItem'
import TabsPane from './src/components/TabsPane'
import Toast from './src/components/Toast'
import plugin from "./src/plugin";



export {
  Button, ButtonGroup, Icon, Col, Collapse, CollapseItem, Content, Footer, Header,
  Input, Layout, Popover, Row, Sider, Tabs, TabsBody, TabsHead, TabsItem, TabsPane, Toast, plugin
}